import httpClient from '@xto10x/core/lib/httpClient';

const teamsApi = {
  getTeamsList: (type, isTag = false) =>
    httpClient.get('/v1/tags', { type, tag: isTag }),

  getManageTagsList: () => httpClient.get('/v1/tags/managed', { tag: true }),

  updateTagsBulk: requestBody => httpClient.put('/v1/tags', requestBody),

  createTeamRequest: requestBody =>
    httpClient.post('/v1/tags', { ...requestBody }),

  updateTeamUsers: (team_id, requestBody) =>
    httpClient.put(`/v1/tags/${team_id}/user-tags`, requestBody),

  updateTeamName: (team_id, label) =>
    httpClient.put(`/v1/tags/${team_id}`, { label }),

  updateTeamDescription: (team_id, description) =>
    httpClient.put(`/v1/tags/${team_id}/description`, { description }),

  deleteTeam: team_id => httpClient.delete(`/v1/tags/${team_id}`),

  getTeamDetails: team_id => httpClient.get(`/v1/tags/${team_id}`)
};

export default teamsApi;
